import React from 'react';
import ReactDOM from 'react-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';
import NoSsr from '@material-ui/core/NoSsr';

interface LoaderProps {}

const Loader: React.FC<LoaderProps> = () => {
  return ReactDOM.createPortal(
    <NoSsr>
      <Backdrop open style={{ zIndex: 99999, color: '#fff' }}>
        <CircularProgress color='inherit' />
      </Backdrop>
    </NoSsr>,
    document.body,
  );
};

export default Loader;
